import { useCallback } from "react";
import {
  useDisableCategory,
  useEnableCategory,
} from "../mutations/useStatusCategoryToggle.mutation";

export const useCategoryStatusToggle = () => {
  const disableMutation = useDisableCategory();
  const enableMutation = useEnableCategory();

  const handleEnable = useCallback(
    (id: string) => {
      enableMutation.mutate(id);
    },
    [enableMutation],
  );

  const handleDisable = useCallback(
    (id: string) => {
      disableMutation.mutate(id);
    },
    [disableMutation],
  );

  return {
    handleDisable,
    isDisabling: disableMutation.isPending,
    handleEnable,
    isEnabling: enableMutation.isPending,
  };
};
